// Action Types
// export const FETCH_IMAGES_REQUEST = "FETCH_IMAGES_REQUEST";
export const GET_TAGGED_MEDIA_SUCCESS = "GET_TAGGED_MEDIA_SUCCESS";
export const PUT_IMAGES_REQUEST = "PUT_IMAGES_REQUEST";
export const PUT_IMAGES_SUCCESS = "PUT_IMAGES_SUCCESS";
export const GET_PRESIGNED_URLS_REQUEST = "GET_PRESIGNED_URLS_REQUEST";
export const GET_PRESIGNED_PUT_URLS_REQUEST = "GET_PRESIGNED_PUT_URLS_REQUEST";
export const GET_PRESIGNED_URLS_SUCCESS = "GET_PRESIGNED_URLS_SUCCESS";
export const GET_TAGGED_MEDIA_REQUEST = "GET_TAGGED_MEDIA_REQUEST";
export const GET_PRESIGNED_GET_URLS_REQUEST = "GET_PRESIGNED_GET_URLS_REQUEST";

// Action Creator for successfully fetching images
export const getTaggedMediaSuccess = (images) => ({
  type: GET_TAGGED_MEDIA_SUCCESS,
  payload: images,
});

// Action Creator for putting images
export const putImagesRequest = (payload) => ({
  type: PUT_IMAGES_REQUEST,
  payload,
});

// Action Creator for successfully putting images
export const putImagesSuccess = (response) => ({
  type: PUT_IMAGES_SUCCESS,
  payload: response,
});

export const getPresignedUrlsRequest = (fileNames) => {
  console.log(
    `PMM - SF - imageActions.jsx- getPresignedUrlsRequest - filenames is: ${JSON.stringify(
      fileNames
    )}`
  );
  const actionPayload = {
    type: GET_PRESIGNED_URLS_REQUEST,
    payload: fileNames,
  };
  return actionPayload;
};

export const getPresignedGetUrlsRequest = (fileNames) => {
  console.log(
    `PMM - SF - imageActions.js - getPresignedGetUrlsRequest initiated - fileNames is: ${JSON.stringify(
      fileNames
    )}`
  );
  const actionPayload = {
    type: GET_PRESIGNED_GET_URLS_REQUEST,
    payload: fileNames,
  };
  return actionPayload;
};

export const getPresignedPutUrlsRequest = (fileNames) => {
  console.log(
    `PMM - SF - imageActions.jsx- getPresignedPutUrlsRequest - filenames is: ${JSON.stringify(
      fileNames
    )}`
  );
  const actionPayload = {
    type: GET_PRESIGNED_PUT_URLS_REQUEST,
    payload: fileNames,
  };
  return actionPayload;
};

export const getTaggedMedia = (tagSet) => {
  console.log(
    `PMM - SF - imageActions.js - getTaggedMedia initiated - fileNames is: ${JSON.stringify(
      tagSet
    )}`
  );
  const actionPayload = {
    type: GET_TAGGED_MEDIA_REQUEST,
    payload: tagSet,
  };
  return actionPayload;
};

// Action Creator for successfully getting pre-signed URLs
export const getPresignedUrlsSuccess = (urls) => ({
  type: GET_PRESIGNED_URLS_SUCCESS,
  payload: urls,
});
